import axios from 'axios';

// Get API URL from environment variables
const getApiUrl = () => {
  // Use environment variable if available, otherwise fallback to mode-based URLs
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }else{
    return 'https://api.tokscript.com/api';
  }
};

const API_URL = getApiUrl();

// Get configuration from environment
const config = {
  timeout: parseInt(import.meta.env.VITE_API_TIMEOUT) || 120000, // Increased to 120s for production
  enableLogging: import.meta.env.VITE_ENABLE_API_LOGGING === 'true',
  tokenStorageKey: import.meta.env.VITE_TOKEN_STORAGE_KEY || 'adminToken',
  refreshTokenKey: import.meta.env.VITE_REFRESH_TOKEN_KEY || 'refreshToken',
};

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  timeout: config.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(config.tokenStorageKey || 'adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // Log API requests in development/staging
    if (config.enableLogging && import.meta.env.MODE !== 'production') {
      console.log(`[API Request] ${config.method?.toUpperCase()} ${config.url}`, config.data);
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor to handle auth errors and logging
api.interceptors.response.use(
  (response) => {
    // Log API responses in development/staging
    if (config.enableLogging && import.meta.env.MODE !== 'production') {
      console.log(`[API Response] ${response.status} ${response.config?.url}`, response.data);
    }
    return response;
  },
  (error) => {
    // Log API errors in development/staging
    if (config.enableLogging && import.meta.env.MODE !== 'production') {
      console.error(`[API Error] ${error.response?.status || 'Network Error'} ${error.config?.url}`, error.response?.data || error.message);
    }
    
    if (error.response?.status === 401) {
      localStorage.removeItem(config.tokenStorageKey);
      localStorage.removeItem(config.refreshTokenKey);
      localStorage.removeItem('adminUser');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;